import React, { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { SearchBarRef, SearchProps } from '../types';
import SearchBar from './SearchBar';

const Search = forwardRef<SearchBarRef, SearchProps>((props, ref) => {
  const { className, searchText, setSearch, placeholder } = props;

  return (
    <>
      <Box
        className={cn(
          'search-input-container sticky top-0 z-20 -mx-28 bg-bg-primary px-20 pt-22 pb-12 xs:-mx-20',
          className,
        )}>
        <SearchBar
          ref={ref}
          className="search-input w-full"
          placeholder={placeholder}
          searchText={searchText}
          setSearch={setSearch}
        />
      </Box>
    </>
  );
});

export default Search;
